import { Box, Card, Container, Typography } from "@mui/material";
import { ReactNode } from "react";
import { COLOR } from "../../utils/colors";
import { VIEW } from "../../utils/breakpoint";
import autove from '../../assets/logo-autovex.png';
import MarkdownText from "../molecules/MarkdownText";
import { parseAsBoolean, useQueryState } from "nuqs";
import { ArrowBack } from "@mui/icons-material";


export default function TextLayout({
  children,
  title,
  lastUpdated
}: {
  children: string | ReactNode
  title: string
  lastUpdated: string
}) {
  const [isDisableDesign] = useQueryState("no_card", parseAsBoolean.withDefault(true));
  const [isDisableLogo] = useQueryState("no_logo", parseAsBoolean.withDefault(false));
  const [isHideCardOnMobile] = useQueryState("hide_card_on_mobile", parseAsBoolean.withDefault(true));
  const [isDisableFooter] = useQueryState("no_footer", parseAsBoolean.withDefault(false));
  const [isDisableBack] = useQueryState("no_back", parseAsBoolean.withDefault(false));
  const handleBackClick = () => {
    window.history.back();
  }
  return (
    <Box
      sx={{
        backgroundColor: isDisableDesign ? COLOR.white : COLOR.neutral[100]
      }}
    >
      <Container
      >
        <Box
          sx={(theme) => ({
            padding: 4,
            pt: 8,
            pb: 12,
            maxWidth: '1000px',
            margin: 'auto',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            color: COLOR.black,
            [theme.breakpoints.down(VIEW.TABLET)]: {
              paddingInline: 0,
              pt: 4,
              pb: 12
            }
          })}>
          {!isDisableBack && (
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                mt: '-12px',
                mb: '24px'
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  justifyContent: 'flex-start',
                  paddingTop: '8px',
                  paddingBottom: '8px',
                  cursor: 'pointer'
                }}
                onClick={handleBackClick}
              >
                <ArrowBack />
                <Typography>
                  Back
                </Typography>
              </Box>
            </Box>
          )}
          {!isDisableLogo && (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                mb: '24px'
              }}
            >
              <img src={autove} alt="Autove Logo" height="36" style={{ borderRadius: "10px" }} />
            </Box>
          )}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              mb: '48px'
            }}
          >
            <Typography
              sx={{ fontFamily: 'Poppins', fontWeight: '600', fontSize: '42px', mb: '-10px' }}
            >
              {title}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.5, gap: 0.5 }}>
              <Typography sx={{ color: COLOR.gray[600] }}>
                Last Updated:
              </Typography>
              <Typography sx={{ color: COLOR.gray[900], fontWeight: '500' }}>
                {lastUpdated}
              </Typography>
            </Box>
          </Box>

          <Box>
            {!isDisableDesign && (
              <Card
                variant="outlined"
                sx={(theme) => ({
                  width: '100%',
                  display: 'block',
                  [theme.breakpoints.down(VIEW.TABLET)]: {
                    display: isHideCardOnMobile ? 'none' : 'block'
                  }
                })}>
                <Box sx={(theme) => ({
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '24px',
                  [theme.breakpoints.down(VIEW.TABLET)]: {
                    padding: '12px',
                  }
                })}>
                  <MarkdownText>
                    {children}
                  </MarkdownText>
                </Box>
              </Card>
            )}
            <Box
              sx={(theme) => ({
                display: isDisableDesign ? 'block' : 'none',
                [theme.breakpoints.down(VIEW.TABLET)]: {
                  display: isHideCardOnMobile ? 'block' : 'none',
                  padding: '12px',
                }
              })}>
              <MarkdownText>
                {children}
              </MarkdownText>
            </Box>
          </Box>
          {!isDisableFooter && (
            <Box
              sx={(theme) => ({
                mt: 12,
                [theme.breakpoints.down(VIEW.TABLET)]: {
                  mt: 8
                }
              })}>
              <Typography
                sx={{
                  fontFamily: 'Poppins',
                  // fontWeight: '600',
                  fontSize: '14px',
                  color: COLOR.gray[900]
                }}
              >
                © {new Date().getFullYear()} by AutoveX Pte Ltd
              </Typography>
            </Box>
          )}
        </Box>
      </Container>
    </Box>
  );
}
